export default "__VITE_ASSET__uQHr0kJz__"